var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"script"}},[_c('button',{on:{"click":function($event){return _vm.run()}}},[_vm._v("Run")])])}
var staticRenderFns = []

export { render, staticRenderFns }